import React, { useState, useEffect, forwardRef, Fragment } from "react";
import {Grid,
        Input,
        Box,
        Typography,
        Switch,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        Slider
} from "@material-ui/core";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { Button } from '../../components/Wrappers'
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import classnames from "classnames";
import layoutImage from "../../images/layout.png";
import './ViewInvoicingSummary.css'


const ViewInvoicingSummary = forwardRef((props, ref) => {

    const classes = useStyles();
    const adminRoles = JSON.parse(localStorage.getItem("admin_roles"));
    const xeroRole = adminRoles?.includes("XERO");
    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [summary, setSummary] = useState(undefined);
    const [chargeableHoursDateDesc, setChargeableHoursDateDesc] = useState('');
    const [isLandscape, setIsLandscape] = useState(false);
    const [isHideImage, setIsHideImage] = useState(false);
    const [numColumns, setNumColumns] = useState(1);
    const [zoomValue, setZoomValue] = useState(100);
    const [openPaperFriendlyAlertDialog, setOpenPaperFriendlyAlertDialog] = useState(false);
    const [paperStyle,setPaperStyle] = useState({});

    var monthFull = new Array();
  	monthFull[0] = "January";
  	monthFull[1] = "February";
  	monthFull[2] = "March";
  	monthFull[3] = "April";
  	monthFull[4] = "May";
  	monthFull[5] = "June";
  	monthFull[6] = "July";
  	monthFull[7] = "August";
  	monthFull[8] = "September";
  	monthFull[9] = "October";
  	monthFull[10] = "November";
  	monthFull[11] = "December";

    var dayFull = new Array();
  	dayFull[0] = "Sunday";
  	dayFull[1] = "Monday";
  	dayFull[2] = "Tuesday";
  	dayFull[3] = "Wednesday";
  	dayFull[4] = "Thursday";
  	dayFull[5] = "Friday";
  	dayFull[6] = "Saturday";

    const handleZoomSliderChange = (event, newValue) => {
      setZoomValue(newValue);
      //updatePaperStyle(newValue, numColumns);
    };

    const handleZoomInputChange = (event) => {
      setZoomValue(event.target.value === '' ? '' : Number(event.target.value));
      //updatePaperStyle(event.target.value === '' ? 0 : Number(event.target.value), numColumns);
    };

    const handleZoomBlur = () => {
       if (zoomValue < 0) {
         setZoomValue(0);
         //updatePaperStyle(0,numColumns);
       } else if (zoomValue > 100) {
         setZoomValue(100);
         //updatePaperStyle(100,numColumns);
       }
     };

     useEffect(() => {
       if (isLandscape) {
         setPaperStyle({display: 'block', zoom: `${zoomValue}%`, columnCount:`${numColumns}`});
       }
       else {
          setPaperStyle({display: 'block'});
       }
     },[zoomValue,numColumns, isLandscape]);

    useEffect(() => {
        let mounted = true;
        const jobId = locationState === undefined ? paramsId : locationState.jobId;
        async function fetchData() {
            const response = await ttAPI.getInvoicingSummary(jobId);
            if (response !== null && response !== undefined && response.details !== null && response.details !== undefined) {
              response.details.instructions = response.details.instructions === undefined || response.details.instructions === null ? '' : replaceNewlineToHtmlBreak(replaceTag(response.details.instructions));
              response.details.site_address = response.details.site_address === undefined || response.details.site_address === null ? '' : replaceNewlineToHtmlBreak(replaceTag(response.details.site_address));
              response.details.hide_site_code = response.details.site_code === undefined || response.details.site_code === null || response.details.site_code.trim() === '';
              setupChargeableHoursDateDesc(response.details.job_start, response.details.job_finish);

              // ordered by name first in the my-app.html after uncompleted jobs fetched (so the jobs page have ordered names)
              // here the parking is ordered by date
              var i;
              for(i in response.details.job_worker_details) {
                  response.details.job_worker_details[i].total_days =  getDaysOnSitebyAccountId(response.details.job_worker_details[i].account_id, response.days_on_site);

                  if (response.details.job_worker_details[i].parking_per_time_entry_array != null &&
                      response.details.job_worker_details[i].parking_per_time_entry_array.length > 0) {
                    response.details.job_worker_details[i].parking_per_time_entry_array.sort(function(a,b){
                        var dateA = convertDateToLocalTimezone(a.timer_start);
                          var dateB = convertDateToLocalTimezone(b.timer_start);
                        return dateA > dateB ? 1 : (dateA < dateB ? -1 : 0);
                      });
                  }
              }

              response.reported_uploads = {total: 0, total_tags_electrical: 0, total_tags_fire: 0, total_tags_first_aid: 0, total_tags_medical: 0, total_tags_rcd: 0, total_tags_3ph: 0, total_repair: 0};
              response.actual_uploads = {total: 0, total_tags_electrical: 0, total_tags_fire: 0, total_tags_first_aid: 0, total_tags_medical: 0, total_tags_rcd: 0, total_tags_3ph: 0, total_repair: 0};
              if (response.uploads !== undefined && response.upload !== null) {
                  if (response.uploads[0] !== undefined && response.uploads[0] !== null) {
                    response.uploads[0].forEach((reprotedUpload, index) => {
                        response.reported_uploads.total += (reprotedUpload.total_tags_electrical + reprotedUpload.total_tags_fire + reprotedUpload.total_tags_firstaid + reprotedUpload.total_tags_medical + reprotedUpload.total_tags_rcd + reprotedUpload.total_tags_3ph + reprotedUpload.total_repairs);
                        response.reported_uploads.total_tags_electrical += reprotedUpload.total_tags_electrical;
                        response.reported_uploads.total_tags_fire += reprotedUpload.total_tags_fire;
                        response.reported_uploads.total_tags_first_aid += reprotedUpload.total_tags_firstaid;
                        response.reported_uploads.total_tags_medical += reprotedUpload.total_tags_medical;
                        response.reported_uploads.total_tags_rcd += reprotedUpload.total_tags_rcd;
                        response.reported_uploads.total_tags_3ph += reprotedUpload.total_tags_3ph;
                        response.reported_uploads.total_repair += reprotedUpload.total_repairs;
                    });
                  }
                  if (response.uploads[2] !== undefined && response.uploads[2] !== null) {
                    response.uploads[2].forEach((actualUpload, index) => {
                        response.actual_uploads.total += (actualUpload.total_tags_electrical + actualUpload.total_tags_fire + actualUpload.total_tags_first_aid + actualUpload.total_tags_medical + actualUpload.total_tags_rcd + actualUpload.total_tags_3ph + actualUpload.total_repair);
                        response.actual_uploads.total_tags_electrical += actualUpload.total_tags_electrical;
                        response.actual_uploads.total_tags_fire += actualUpload.total_tags_fire;
                        response.actual_uploads.total_tags_first_aid += actualUpload.total_tags_first_aid;
                        response.actual_uploads.total_tags_medical += actualUpload.total_tags_medical;
                        response.actual_uploads.total_tags_rcd += actualUpload.total_tags_rcd;
                        response.actual_uploads.total_tags_3ph += actualUpload.total_tags_3ph;
                        response.actual_uploads.total_repair += actualUpload.total_repair;
                    });
                  }
              }

              if(mounted){
                  setSummary(response);
              }
            }
        }


        if (jobId !== undefined && jobId > 0) {
            fetchData();
        }

        return () => mounted = false;
    },[locationState, paramsId]);

    function replaceNewlineToHtmlBreak(str) {
    	return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    function replaceTag(str) {
      return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function setupChargeableHoursDateDesc(jobStart, jobFinish) {
        	var startJobDate = convertDateToLocalTimezone(jobStart);
        	var endJobDate = convertDateToLocalTimezone(jobFinish);
        	var diff = getDiffInDay(startJobDate, endJobDate);
        	if (diff == 1) {
        		setChargeableHoursDateDesc(formatChargableHoursDate(startJobDate) + ' (Total of 1 Day)');
        	}
        	else {
        		setChargeableHoursDateDesc(formatChargableHoursDate(startJobDate) +
                                      ' - ' +
                                      formatChargableHoursDate(endJobDate) +
        		                          ' (Total of ' + diff +' Days)');
        	}
    }

    function formatChargableHoursDate(date) {
            // here the d comes from server, from a column
            // without timeozone
            // we only care about the correct date and time
            //var date = this.convertDateToLocalTimezone(d);
            return getDayFullName(date) + ', ' +  date.getDate() + " " +
                   getMonthFullName(date) + " " +
                   date.getFullYear().toString().slice(-2);
    }

    function getDayFullName(d) {
    	  return dayFull[d.getDay()];
    }

    function getMonthFullName(d) {
        return monthFull[d.getMonth()];
    }

    function convertDateToLocalTimezone(d) {
        // This method keeps the date and time
        // of whatever parsed in and change the
        // timezone to local timezone
        var date;
        if (d instanceof Date) {
            date = new Date();
            date.setFullYear(d.getFullYear());
            date.setMonth(d.getMonth());
            date.setDate(d.getDate());
            date.setHours(d.getHours());
            date.setMinutes(d.getMinutes());
        }
        else {
            // if it is a utc string
            if ((String(d)).indexOf('T') > -1) {
                d = d.replace('T', ' ');
            }
            date = new Date(d);
        }
        return date;
    }

    function getDiffInDay(date1, date2) {
    	  var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    function getDaysOnSitebyAccountId(accountId, daysOnSite) {
    	var i;
    	for(i in daysOnSite) {
    		if (daysOnSite[i].account_id == accountId) {
    			return daysOnSite[i].total_days;
    		}
    	}
    	return 0;
    }

    function getTotalWorkerHours() {
      	var total = 0;
      	var i;
      	for(i in summary.details.job_worker_details) {
      		total += summary.details.job_worker_details[i].hour;
      	}
      	return total.toFixed(2);
    }

    function getTotalWorkerDays() {
        var total = 0;
        var i;
        for(i in summary.details.job_worker_details) {
            total += summary.details.job_worker_details[i].total_days;
        }
        return total;
    }

    function formatParkingDate(d) {
        	var date = convertDateToLocalTimezone(d);
        	return date.getDate() + " " +  getMonthFullName(date) + " " + date.getFullYear().toString().slice(-2);
    }

    function getTotalParking() {
         var total = 0;
         var i;
         for(i in summary.parkings) {
           total += summary.parkings[i].parking;
           }
           return total.toFixed(2);
    }

    function paperSaverFriendlyAlert() {
      setOpenPaperFriendlyAlertDialog(!isLandscape);
      setIsLandscape(!isLandscape);

      if (!isLandscape) {
        setZoomValue(80);
        setNumColumns(2);
        //updatePaperStyle(zoomValue,numColumns);
      }

    }

    function print() {
       window.print();
    }

    const handleClosePaperFriendlyAlertDialog = () => {
      setOpenPaperFriendlyAlertDialog(false);
    };

    function onClickHideImage() {
      setIsHideImage(!isHideImage);
    }

    function loginXero() {
        // this will redirect to xero page,
        /*if (config.clientApi.includes('uat')) {
            window.open(`${config.clientApi}/xero.html?jobId=${summary.details.id}`,'_blank');
        }
        else {
          window.open(`http://app.testandtag.co.nz/client/xero.html?jobId=${summary.details.id}`,'_blank');
        }*/
        window.open(`${config.clientApi}/xero.html?jobId=${summary.details.id}`,'_blank');

        //window.open("/client/myob.html?jobId="+this.invoicingStatus.jobId","Myob","height=768,width=1024");

    }

    function getTotalRepairs() {
    	var total = 0;
    	var i;
        for(i in summary.repairs) {
            total += summary.repairs[i].repair_count;
        }
        return total;
    }

    function isString(s) {
      return typeof s === 'string' || s instanceof String;
    }

    return (
      <div className={classes.contentDiv}>
      {summary &&
          <Grid container spacing={0}>
              <Grid item xs={12}>
              {isLandscape && <Box component="div" className={classes.toolbar} displayPrint="none">
                  <div>Print Settings:</div>
                  <div className={classes.footer}>Please adjust the zoom level and columns so that everything fits in the <b>white box</b> below.</div>
                  <div className={classes.toolbarContent}>
                    <div className={classes.zoomDiv}>
                    <Typography id="input-slider" style={{ fontSize: '12px'}} gutterBottom>
                      Zoom
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs>
                        <Slider
                          value={zoomValue}
                          onChange={handleZoomSliderChange}
                          aria-labelledby="input-slider"
                        />
                      </Grid>
                      <Grid item>
                        <Input
                          className={classes.input}
                          value={zoomValue}
                          margin="dense"
                          onChange={handleZoomInputChange}
                          onBlur={handleZoomBlur}
                          inputProps={{
                            step: 1,
                            min: 0,
                            max: 100,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                          }}
                        />
                      </Grid>
                    </Grid>
                    </div>

                    <div className={classes.columnCountContainer}>
                      <Typography id="input-slider" style={{ fontSize: '12px'}} gutterBottom>
                        Columns
                      </Typography>
                      <Input
                        className={classes.input}
                        value={numColumns}
                        margin="dense"
                        onChange={(event) => {
                          var cols = isNaN(event.target.value)
                                        ? 1
                                        : (event.target.value <= 0
                                            ? (event.target.value = 1)
                                            : event.target.value);
                          //updatePaperStyle(zoomValue, cols);
                          setNumColumns(cols);}
                          }
                        inputProps={{
                          step: 1,
                          min: 1,
                          max: 100,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />

                    </div>

                    <div className={classes.toolbarHideImageDiv}>
                        <Box display={"flex"} alignItems={"center"}>
                        <Switch color={"primary"} checked={isHideImage} onClick={onClickHideImage}/>
                            <Typography weight={"medium"}>
                                Hide Image(s)
                            </Typography>

                        </Box>
                    </div>
                  </div>
                  </Box>}

                  <div id="print-view" className={isLandscape ?  classes.printView : classes.card}>
                  <div
                    style={paperStyle}
                  >
                  <div className={classes.printableArea}>
                  <div className={classes.bigHeader} >
                      <span id="header" className={classes.header}>{`Summary : ${summary.details.customer_name} : ${summary.details.id}`}</span>
                      {/*}, classes.noPrint*/}
                      <Box component="span" className={classnames(classes.topButtons)} displayPrint="none">
                          <Box display={"flex"} alignItems={"center"} className={classes.toolbarBox}>
                              <Typography weight={"medium"}>
                                  Paper Saver
                              </Typography>
                              <Switch color={"primary"} checked={isLandscape}
                                      onClick={paperSaverFriendlyAlert} />

                              {xeroRole && summary.details.completed && <Button className={classnames(classes.button,classes.xeroButton)}
                                  onClick={loginXero}
                              >
                              Open INVOICE IN XERO
                              </Button>}

                              <Button className={classes.button}
                                  onClick={print}
                              >
                              Print
                              </Button>
                          </Box>

        	            {/*}<paper-button class="yellow" autofocus on-tap="loginXero" hidden="{{!isJobCompleted}}">
                            Open Invoice in Xero
                        </paper-button>*/}

        	            </Box>
                  </div>

                  {/*details*/}
                  <div className={classes.details}>
                      <div className={classes.title}>Work Order Number:</div>
                      <div>{`${summary.details.work_order_num}`}</div>

                      <div className={classes.title}>Contact:</div>
                      <div>{`${summary.details.contact}`}</div>

                      <div className={classes.title}>Site:</div>
                      <div dangerouslySetInnerHTML={{__html:  summary.details.site_name}}></div>

                      <div className={classes.title} hidden={summary.details.hide_site_code}>Site Code:</div>
                      <div hidden={summary.details.hide_site_code}>{`${summary.details.site_code}`}</div>

                      <div className={classes.title}>Address:</div>
                      <div dangerouslySetInnerHTML={{__html:  summary.details.site_address}}></div>

                      <div className={classes.title}>Instructions:</div>
                      <div dangerouslySetInnerHTML={{__html:  summary.details.instructions}}></div>

                      <div className={classes.title}  hidden={summary.site_charge_rule == ''}>Site Charge Rule:</div>
                      <div hidden={summary.site_charge_rule == ''}>{`${summary.site_charge_rule.site_rule_used}`}</div>
                  </div>

                  {/*uploads reported by workers*/}
                  <div className={classes.bigTitle}>UPLOADS REPORTED BY WORKERS</div>
                  <div className={classes.reportedUploads}>
                      <div className={classes.title}>Signon</div>
                      <div className={classes.title}>Name</div>
                      <div className={classes.title}>Completed</div>
                      <div className={classnames(classes.title,classes.borderRight)}>Date</div>
                      <div className={classnames(classes.title,classes.centerText)}>1Ph</div>
                      <div className={classnames(classes.title,classes.centerText)}>Fire</div>
                      <div className={classnames(classes.title,classes.centerText)}>First Aid</div>
                      <div className={classnames(classes.title,classes.centerText)}>Medical</div>
                      <div className={classnames(classes.title,classes.centerText)}>RCD</div>
                      <div className={classnames(classes.title,classes.centerText)}>3PH</div>
                      <div className={classnames(classes.title,classes.centerText)}>Repairs</div>

                      {summary.uploads !== undefined && summary.uploads !== null &&
                        summary.uploads[0] !== undefined && summary.uploads[0] !== null &&
                        summary.uploads[0].map((reportedUpload, index) => (
                             [<div key={`${index}_0`}>{`${reportedUpload.signon}`}</div>,
                              <div key={`${index}_1`}>{`${reportedUpload.name}`}</div>,
                              <div key={`${index}_2`}>{`${reportedUpload.completed === null || reportedUpload.completed === undefined ? '' : reportedUpload.completed }`}</div>,
                              <div key={`${index}_3`} className={classes.borderRight}>{`${reportedUpload.completed_response_date}`}</div>,
                              <div key={`${index}_4`} className={classes.centerText}>{`${reportedUpload.total_tags_electrical}`}</div>,
                              <div key={`${index}_5`} className={classes.centerText}>{`${reportedUpload.total_tags_fire}`}</div>,
                              <div key={`${index}_6`} className={classes.centerText}>{`${reportedUpload.total_tags_firstaid}`}</div>,
                              <div key={`${index}_7`} className={classes.centerText}>{`${reportedUpload.total_tags_medical}`}</div>,
                              <div key={`${index}_8`} className={classes.centerText}>{`${reportedUpload.total_tags_rcd}`}</div>,
                              <div key={`${index}_9`} className={classes.centerText}>{`${reportedUpload.total_tags_3ph}`}</div>,
                              <div key={`${index}_10`} className={classes.centerText}>{`${reportedUpload.total_repairs}`}</div>]
                      ))}
                  </div>
                  <div className={classes.reportedUploadsSummary}>
                      <div className={classnames(classes.title,classes.summaryRow)}>TOTAL</div>
                      <div className={classnames(classes.title,classes.summaryRow)}>{summary.reported_uploads.total}</div>
                      <div className={classnames(classes.title,classes.summaryRow)}></div>
                      <div className={classnames(classes.title,classes.borderRight,classes.summaryRow)}></div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_electrical === null ? 0 : summary.reported_uploads.total_tags_electrical}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_fire === null ? 0 : summary.reported_uploads.total_tags_fire}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_first_aid === null ? 0 : summary.reported_uploads.total_tags_first_aid}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_medical === null ? 0 : summary.reported_uploads.total_tags_medical}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_rcd === null ? 0 : summary.reported_uploads.total_tags_rcd}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_3ph === null ? 0 : summary.reported_uploads.total_tags_3ph}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_repair === null ? 0 : summary.reported_uploads.total_repair}</div>
                  </div>
                  <div className={classes.footer}>Completed - Job Completed, Date - Job Completed Response Date</div>

                  {/*actual uploads*/}
                  <div className={classes.bigTitle}>ACTUAL UPLOADS</div>
                  <div className={classes.actualUploads}>
                      <div className={classes.title}>Signon</div>
                      <div className={classes.title}>Name</div>
                      <div className={classes.title}></div>
                      <div className={classnames(classes.title,classes.borderRight)}></div>
                      <div className={classnames(classes.title,classes.centerText)}>1Ph</div>
                      <div className={classnames(classes.title,classes.centerText)}>Fire</div>
                      <div className={classnames(classes.title,classes.centerText)}>First Aid</div>
                      <div className={classnames(classes.title,classes.centerText)}>Medical</div>
                      <div className={classnames(classes.title,classes.centerText)}>RCD</div>
                      <div className={classnames(classes.title,classes.centerText)}>3PH</div>
                      <div className={classnames(classes.title,classes.centerText)}>Repairs</div>

                      {summary.uploads !== undefined && summary.uploads !== null &&
                        summary.uploads[2] !== undefined && summary.uploads[2] !== null &&
                        summary.uploads[2].map((actualUpload, index) => (
                             [<div key={`${index}_0`}>{`${actualUpload.user_signon}`}</div>,
                              <div key={`${index}_1`}>{`${actualUpload.user_name}`}</div>,
                              <div key={`${index}_2`}></div>,
                              <div key={`${index}_3`} className={classes.borderRight}></div>,
                              <div key={`${index}_4`} className={classes.centerText}>{`${actualUpload.total_tags_electrical}`}</div>,
                              <div key={`${index}_5`} className={classes.centerText}>{`${actualUpload.total_tags_fire}`}</div>,
                              <div key={`${index}_6`} className={classes.centerText}>{`${actualUpload.total_tags_first_aid}`}</div>,
                              <div key={`${index}_7`} className={classes.centerText}>{`${actualUpload.total_tags_medical}`}</div>,
                              <div key={`${index}_8`} className={classes.centerText}>{`${actualUpload.total_tags_rcd}`}</div>,
                              <div key={`${index}_9`} className={classes.centerText}>{`${actualUpload.total_tags_3ph}`}</div>,
                              <div key={`${index}_10`} className={classes.centerText}>{`${actualUpload.total_repair}`}</div>]
                      ))}
                  </div>
                  <div className={classes.actualUploadsSummary}>
                      <div className={classnames(classes.title,classes.summaryRow)}>TOTAL</div>
                      <div className={classnames(classes.title,classes.summaryRow)}>{summary.actual_uploads.total}</div>
                      <div className={classnames(classes.title,classes.summaryRow)}></div>
                      <div className={classnames(classes.title,classes.borderRight,classes.summaryRow)}></div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_tags_electrical === null ? 0 : summary.actual_uploads.total_tags_electrical}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_tags_fire === null ? 0 : summary.actual_uploads.total_tags_fire}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_tags_first_aid === null ? 0 : summary.actual_uploads.total_tags_first_aid}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_tags_medical === null ? 0 : summary.actual_uploads.total_tags_medical}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_tags_rcd === null ? 0 : summary.actual_uploads.total_tags_rcd}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_tags_3ph === null ? 0 : summary.actual_uploads.total_tags_3ph}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.actual_uploads.total_repair === null ? 0 : summary.actual_uploads.total_repair}</div>
                  </div>
                  <div className={classes.footer}>(FT) indicates Formtab</div>

                  {/*total difference*/}
                  <div className={classes.bigTitle}>TOTAL DIFFERENCE</div>
                  <div className={classes.diff}>
                      <div className={classnames(classes.title,classes.summaryRow)}>DIFF</div>
                      <div className={classnames(classes.title,classes.summaryRow)}>{summary.reported_uploads.total - summary.actual_uploads.total}</div>
                      <div className={classnames(classes.title,classes.summaryRow)}></div>
                      <div className={classnames(classes.title,classes.borderRight,classes.summaryRow)}></div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_electrical - summary.actual_uploads.total_tags_electrical}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_fire - summary.actual_uploads.total_tags_fire}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_first_aid - summary.actual_uploads.total_tags_first_aid}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_medical - summary.actual_uploads.total_tags_medical}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_rcd - summary.actual_uploads.total_tags_rcd}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_tags_3ph - summary.actual_uploads.total_tags_3ph}</div>
                      <div className={classnames(classes.title,classes.centerText,classes.summaryRow)}>{summary.reported_uploads.total_repair - summary.actual_uploads.total_repair}</div>
                  </div>

                  {/*asset tested without description*/}
                  {summary.uploads !== undefined && summary.uploads !== null &&
                    summary.uploads[1] !== undefined && summary.uploads[1] !== null &&
                    <Fragment>
                      <div className={classes.bigTitle}>ASSET TESTED WITHOUT DESCRIPTION</div>
                      <div className={classes.assetNoDesc}>
                          <div className={classes.title}>Asset ID</div>
                          <div className={classes.title}>Location</div>


                          {summary.uploads[1] !== undefined && summary.uploads[1] !== null &&
                            summary.uploads[1].map((noDescUpload, index) => (
                                 [<div key={`${index}_0`}>{`${noDescUpload.asset}`}</div>,
                                  <div key={`${index}_1`}>{`${noDescUpload.location}`}</div>]
                          ))}
                      </div>
                      <div className={classes.assetNoDescSummary}>
                        <div className={classnames(classes.title,classes.summaryRow)}>TOTAL</div>
                        <div className={classnames(classes.title,classes.summaryRow)}>{summary.uploads[1].length}</div>
                      </div>
                   </Fragment>}

                   {/*chargable hours*/}
                   <div className={classes.bigTitle}>CHARGEABLE HOURS</div>
                   {(summary.details.job_worker_details === undefined ||
                    summary.details.job_worker_details === null ||
                    summary.details.job_worker_details.length <= 0) &&
                    <div className={classnames(classes.title,classes.repairsSummary)}>No Chargeable hours to show yet.</div>}
                   {(summary.details.job_worker_details !== undefined &&
                    summary.details.job_worker_details !== null &&
                    summary.details.job_worker_details.length > 0) &&
                     <Fragment>
                     <div className={classes.title}>The Job was conducted {`${chargeableHoursDateDesc}`}</div>
                     <div className={classes.chargeableHours}>
                         <div className={classes.title}>Technician</div>
                         <div className={classes.title}>Hours</div>
                         <div className={classes.title}>Days On-site</div>
                         {summary.details.job_worker_details.map((worker, index) => (
                              [<div key={`${index}_0`}>{`${worker.worker_name}`}</div>,
                               <div key={`${index}_1`}>{`${worker.hour.toFixed(2)}`}</div>,
                               <div key={`${index}_2`}>{`${worker.total_days}`}</div>]
                          ))}
                     </div>
                     <div className={classes.chargeableHoursSummary1}>
                       <div className={classnames(classes.title,classes.summaryRow)}>TOTAL</div>
                       <div className={classnames(classes.title,classes.summaryRow)}>{getTotalWorkerHours()}</div>
                       <div className={classnames(classes.title,classes.summaryRow)}>{getTotalWorkerDays()}</div>
                     </div>
                     <div className={classes.chargeableHoursSummary2}>
                       <div className={classnames(classes.title,classes.summaryRow)}>TOTAL AS GROUP</div>
                       <div></div>
                       <div className={classnames(classes.title,classes.summaryRow)}>{summary.days_on_site_as_group}</div>
                     </div>
                     </Fragment>
                   }


                   {/*parking*/}
                   <div className={classes.bigTitle}>PARKING</div>
                   {(summary.parkings === undefined ||
                    summary.parkings === null || summary.parkings.length <= 0)
                    &&
                    <div className={classnames(classes.title,classes.parkingSummary)}>No Parking details Submitted</div>}

                    {(summary.parkings !== undefined &&
                     summary.parkings !== null && summary.parkings.length > 0)
                     &&
                     <Fragment>
                       <div className={classes.parking}>
                           <div className={classes.title}>Technician</div>
                           <div className={classes.title}>Date</div>
                           <div className={classes.title}>Spent</div>
                           {summary.parkings.map((parking, index) => (
                                [<div key={`${index}_0`} className={classnames({[classes.lateSubmitText]: parking.late_submit})}>{`${parking.name}`}</div>,
                                 <div key={`${index}_1`} className={classnames({[classes.lateSubmitText]: parking.late_submit})}>{`${formatParkingDate(parking.timer_start)}`}</div>,
                                 <div key={`${index}_2`} className={classnames({[classes.flex]: true, [classes.lateSubmitText]: parking.late_submit})}><AttachMoneyIcon/>{`${parking.parking.toFixed(2)}`}</div>]
                            ))}
                       </div>
                       <div className={classes.parkingSummary}>
                           <div className={classnames(classes.title,classes.summaryRow)}>TOTAL</div>
                           <div></div>
                           <div className={classnames(classes.title,classes.summaryRow, classes.flex)}><AttachMoneyIcon/>{getTotalParking()}</div>
                       </div>
                      </Fragment>}

                      {/*parking per person*/}
                      <div className={classes.bigTitle}>PARKING PER TECHNICIAN</div>
                      {(summary.parkings_per_person === undefined ||
                       summary.parkings_per_person === null || summary.parkings_per_person.length <= 0)
                       &&
                       <div className={classnames(classes.title,classes.parkingSummary)}>No Parking details Submitted</div>}

                       {(summary.parkings_per_person !== undefined &&
                        summary.parkings_per_person !== null && summary.parkings_per_person.length > 0)
                        &&
                        <Fragment>
                          <div className={classes.parkingPerTech}>
                              <div className={classes.title}>Technician</div>
                              <div className={classes.title}>Spent TOTAL</div>
                              {summary.parkings_per_person.map((parking_pp, index) => (
                                   [<div key={`ppp_${index}_0`}>{`${parking_pp.name}`}</div>,
                                    <div key={`ppp_${index}_1`} className={classnames({[classes.flex]: true})}><AttachMoneyIcon/>{`${parking_pp.total_parking.toFixed(2)}`}</div>]
                               ))}
                          </div>
                         </Fragment>}

                      {/*asset test summary*/}
                      <div className={classes.bigTitle}>ASSET TEST SUMMARY</div>
                      <div className={classes.title}>Please check the Upload Summary Report for detailed breakdown.</div>
                      <div className={classes.assetTestSummary}>
                          <div className={classes.title}>Asset Tag Type</div>
                          <div className={classes.title}>Total Uploaded</div>

                          {summary.tag_stats.electrical_tags !== undefined &&
                           summary.tag_stats.electrical_tags !== null &&
                           summary.tag_stats.electrical_tags > 0 &&
                           <Fragment>
                               <div>1PH</div>
                               <div>{summary.tag_stats.electrical_tags}</div>
                           </Fragment>}

                           {summary.tag_stats.six_or_more_multibox !== undefined &&
                            summary.tag_stats.six_or_more_multibox !== null &&
                            summary.tag_stats.six_or_more_multibox > 0 &&
                            <Fragment>
                                <div>6+ Multi Box</div>
                                <div>{summary.tag_stats.six_or_more_multibox}</div>
                            </Fragment>}

                           {summary.tag_stats.exit_tags !== undefined &&
                              summary.tag_stats.exit_tags !== null &&
                              summary.tag_stats.exit_tags > 0 &&
                              <Fragment>
                                  <div>Exit Light</div>
                                  <div>{summary.tag_stats.exit_tags}</div>
                              </Fragment>}

                          {summary.tag_stats.first_aid_tags !== undefined &&
                             summary.tag_stats.first_aid_tags !== null &&
                             summary.tag_stats.first_aid_tags > 0 &&
                             <Fragment>
                                 <div>First Aid</div>
                                 <div>{summary.tag_stats.first_aid_tags}</div>
                             </Fragment>}

                          {summary.tag_stats.medical_tags !== undefined &&
                              summary.tag_stats.medical_tags !== null &&
                              summary.tag_stats.medical_tags > 0 &&
                              <Fragment>
                                  <div>Medical</div>
                                  <div>{summary.tag_stats.medical_tags}</div>
                              </Fragment>}

                          {summary.rcd_details_count !== undefined &&
                           summary.rcd_details_count !== null &&
                           summary.rcd_details_count.length > 0 &&
                           <Fragment>
                               {summary.rcd_details_count.map((rcd_dc, index) => (
                                    [<div key={`${index}_0`}>{`${rcd_dc.description}`}</div>,
                                     <div key={`${index}_1`}>{`${rcd_dc.count}`}</div>]
                                ))}
                            </Fragment>
                          }

                          {summary.fire_details_count !== undefined &&
                           summary.fire_details_count !== null &&
                           summary.fire_details_count.length > 0 &&
                           <Fragment>
                               {summary.fire_details_count.map((fire_dc, index) => (
                                    [<div key={`${index}_0`}>{`${fire_dc.description}`}</div>,
                                     <div key={`${index}_1`}>{`${fire_dc.count}`}</div>]
                                ))}
                            </Fragment>
                          }

                          {summary.lg_details_count !== undefined &&
                           summary.lg_details_count !== null &&
                           summary.lg_details_count.length > 0 &&
                           <Fragment>
                               {summary.lg_details_count.map((lg_dc, index) => (
                                    [<div key={`${index}_0`}>{`${lg_dc.description}`}</div>,
                                     <div key={`${index}_1`}>{`${lg_dc.count}`}</div>]
                                ))}
                            </Fragment>
                          }

                          {summary.tag_stats.repairs_tags !== undefined &&
                           summary.tag_stats.repairs_tags !== null &&
                           summary.tag_stats.repairs_tags > 0 &&
                           <Fragment>
                               <div>Repairs</div>
                               <div>{summary.tag_stats.repairs_tags}</div>
                           </Fragment>}

                           {summary.tag_stats.three_phase_tags !== undefined &&
                            summary.tag_stats.three_phase_tags !== null &&
                            summary.tag_stats.three_phase_tags > 0 &&
                            <Fragment>
                                <div>3PH</div>
                                <div>{summary.tag_stats.three_phase_tags}</div>
                            </Fragment>}

                            {summary.tag_stats.rcd_three_phase_details_count !== undefined &&
                              summary.tag_stats.rcd_three_phase_details_count !== null &&
                              summary.tag_stats.rcd_three_phase_details_count.length > 0 &&
                              <Fragment>
                                  {summary.tag_stats.rcd_three_phase_details_count.map((rcd3p, index) => (
                                      [<div key={`${index}_0`}>{`${rcd3p.description}`}</div>,
                                       <div key={`${index}_1`}>{`${rcd3p.count}`}</div>]
                                  ))}
                              </Fragment>
                             }

                            {summary.tag_stats.microwave_tags !== undefined &&
                                summary.tag_stats.microwave_tags !== null &&
                                summary.tag_stats.microwave_tags > 0 &&
                            <Fragment>
                                <div>Microwave</div>
                                <div>{summary.tag_stats.microwave_tags}</div>
                            </Fragment>}

                            {summary.tag_stats.microwave_leakage_tags !== undefined &&
                             summary.tag_stats.microwave_leakage_tags !== null &&
                             summary.tag_stats.microwave_leakage_tags > 0 &&
                             <Fragment>
                                 <div>Microwave LKG</div>
                                 <div>{summary.tag_stats.microwave_leakage_tags}</div>
                             </Fragment>}

                            {summary.tag_stats.aed_tags !== undefined &&
                             summary.tag_stats.aed_tags !== null &&
                             summary.tag_stats.aed_tags > 0 &&
                             <Fragment>
                                <div>AED</div>
                                <div>{summary.tag_stats.aed_tags}</div>
                             </Fragment>}

                            {summary.tag_stats.evse_tags !== undefined &&
                             summary.tag_stats.evse_tags !== null &&
                             summary.tag_stats.evse_tags > 0 &&
                             <Fragment>
                                 <div>EVSE</div>
                                 <div>{summary.tag_stats.evse_tags}</div>
                             </Fragment>}

                            {summary.tag_stats.non_electrical_tags !== undefined &&
                             summary.tag_stats.non_electrical_tags !== null &&
                             summary.tag_stats.non_electrical_tags.length > 0 &&
                             <Fragment>
                                {summary.tag_stats.non_electrical_tags.map((net, index) => (
                                     [<div key={`${index}_0`}>{`${net.description}`}</div>,
                                      <div key={`${index}_1`}>{`${net.count}`}</div>]
                                 ))}
                             </Fragment>}
                      </div>
                      <div className={classes.assetTestSummarySummary}></div>

                      {/*duplicated tests*/}
                      {summary.duplicated_asset_tests !== undefined &&
                       summary.duplicated_asset_tests !== null &&
                       summary.duplicated_asset_tests.length > 0 &&
                       <Fragment>
                           <div className={classes.bigTitle}>DUPLICATED TESTS ({summary.duplicated_asset_tests.length})</div>
                           <div className={classes.duplicatedTests}>
                               <div className={classes.title}>Asset</div>
                               <div className={classes.title}>Uploaded By</div>
                               <div className={classes.title}>Uploaded</div>
                               <div className={classes.title}>Tested</div>
                               <div className={classes.title}>Passed</div>
                               <div className={classes.title}>Description</div>
                               <div className={classes.title}>Location</div>

                               {summary.duplicated_asset_tests.map((dat, index) => (
                                    [<div key={`${index}_0`} className={classes.breakable}>{`${dat.asset}`}</div>,
                                     <div key={`${index}_1`}>{`${dat.name}`}</div>,
                                     <div key={`${index}_2`}>{`${dat.createdate === undefined || dat.createdate === null ? '' : dat.createdate}`}</div>,
                                     <div key={`${index}_3`}>{`${dat.tested}`}</div>,
                                     <div key={`${index}_3`}>{`${dat.passed ? 'YES' : 'NO'}`}</div>,
                                     <div key={`${index}_4`}>{`${dat.description}`}</div>,
                                     <div key={`${index}_5`}>{`${dat.location}`}</div>]
                                ))}
                           </div>
                       </Fragment>
                      }

                      {/*repairs performed*/}
                      <div className={classes.bigTitle}>REPAIRS PERFORMED</div>
                      {(summary.repairs === undefined ||
                       summary.repairs === null ||
                       summary.repairs.length <= 0) &&
                       <div className={classnames(classes.title,classes.repairsSummary)}>No Repair Details Submitted</div>}

                       {summary.repairs !== undefined &&
                        summary.repairs !== null &&
                        summary.repairs.length > 0 &&
                        <Fragment>
                        {summary.repairs.map((repair, index) => (
                             [<div key={`${index}_0`} className={classnames(classes.title,classes.breakWord)}>{`${repair.repair} ${repair.repair_count}`}</div>,
                              <div key={`${index}_1`} className={classes.repariDetails}>
                               {repair.repair_details.map((rd, ind) => (
                                    [<div key={`${ind}_10`}>{rd.asset_code}
                                      {!isHideImage && <div>
                                          <img src={`${config.googleStorageUrl}${rd.qr}`} className={classes.failedImage}
                                          onError={(e) => {
                                              e.target.src = 'https://via.placeholder.com/468x372?text=NO+IMAGE'
                                            }}/>
                                      </div>}
                                      </div>,
                                     <div key={`${ind}_11`}>{rd.worker_name}</div>,
                                     <div key={`${ind}_12`}>{rd.create_date}</div>,
                                     <div key={`${ind}_12`}>{rd.note}</div>
                                     ]
                                ))}
                                </div>]
                         ))}
                         <div className={classes.repairsSummary}>
                             <div className={classnames(classes.title,classes.summaryRow)}>TOTAL</div>
                             <div className={classnames(classes.title,classes.summaryRow)}>{getTotalRepairs()}</div>
                         </div>
                         </Fragment>
                        }

                        {/*faulty items*/}
                        <div className={classes.bigTitle}>FAULTY ITEMS
                         {summary.failed_assets !== undefined &&
                          summary.failed_assets !== null &&
                          summary.failed_assets.length > 0 &&
                          <span>{` (${summary.failed_assets.length})`}</span>
                         }
                        </div>
                        {(summary.failed_assets === undefined ||
                         summary.failed_assets === null ||
                         summary.failed_assets.length <= 0) &&
                         <div className={classnames(classes.title,classes.faultyItemsSummary)}>No Faulty Items</div>}

                        {summary.failed_assets !== undefined &&
                         summary.failed_assets !== null &&
                         summary.failed_assets.length > 0 &&
                         <Fragment>
                             <div className={classes.faultyItems}>
                                 <div className={classes.title}>Asset</div>
                                 <div className={classes.title}>Description</div>
                                 <div className={classes.title}>Location</div>
                                 <div className={classes.title}>Note</div>
                                 <div className={classes.title}>Reason</div>

                                 {summary.failed_assets.map((fa, index) => (
                                      [<div key={`${index}_0`}>{`${fa.asset}`}
                                          {!isHideImage && <div>
                                              <img src={`${config.googleStorageUrl}${fa.qr}`} className={classes.failedImage}
                                              onError={(e) => {
                                                  e.target.src = 'https://via.placeholder.com/468x372?text=NO+IMAGE'
                                                }}/>
                                          </div>}
                                       </div>,
                                       <div key={`${index}_1`}>{`${fa.description}`}</div>,
                                       <div key={`${index}_2`}>{`${fa.location}`}</div>,
                                       <div key={`${index}_3`}>{`${fa.note}`}</div>,
                                       <div key={`${index}_4`}>
                                         {fa.reasons.map((reason, ind) => (
                                              [<span key={`${ind}_00`}>{reason}{fa.reasons.length > ind + 1 && <span>,</span>}</span>]
                                          ))}
                                       </div>]
                                  ))}
                             </div>
                             <div className={classes.faultyItemsSummary}></div>
                         </Fragment>
                        }

                        {/*timesheet app notes*/}
                        <div className={classes.bigTitle}>Timesheet App Notes</div>
                        {(summary.notes === undefined ||
                         summary.notes === null ||
                         summary.notes.length <= 0) &&
                         <div className={classnames(classes.title,classes.timesheetSummary)}>No Timesheet App Notes Submitted</div>}

                         {summary.notes !== undefined &&
                          summary.notes !== null &&
                          summary.notes.length > 0 &&
                          <Fragment>
                              <div className={classes.timesheet}>
                                  <div className={classes.title}>Date</div>
                                  <div className={classes.title}>Name</div>
                                  <div className={classes.title}>Note</div>

                                  {summary.notes.map((note, index) => (
                                       [<div key={`${index}_0`}>{`${note.timer_start}`}</div>,
                                        <div key={`${index}_1`}>{`${note.name}`}</div>,
                                        <div key={`${index}_2`} className={classes.breakWord}>{`${note.notes}`}</div>]
                                   ))}
                              </div>
                              <div className={classes.timesheetSummary}></div>
                          </Fragment>
                         }


                        {/*job card app notes*/}
                        <div className={classes.bigTitle}>Job Card App Notes</div>
                        {(summary.job_card_app_notes === undefined ||
                         summary.job_card_app_notes === null ||
                         summary.job_card_app_notes.length <= 0) &&
                         <div className={classnames(classes.title,classes.jobcardSummary)}>No Job Card App Notes Submitted</div>}

                         {summary.job_card_app_notes !== undefined &&
                          summary.job_card_app_notes !== null &&
                          summary.job_card_app_notes.length > 0 &&
                          <Fragment>
                              <div className={classes.jobcard}>
                                  <div className={classes.title}>Name</div>
                                  <div className={classes.title}>Note</div>
                                  <div className={classes.title}>Date</div>

                                  {summary.job_card_app_notes.map((note, index) => (
                                       [<div key={`${index}_0`}>{`${note.name}`}</div>,
                                        <div key={`${index}_1`}>{isString(note.note) ? `${note.note}` : `${note.note.details}`}</div>,
                                        <div key={`${index}_2`}>{isString(note.note) ? `` : `${note.note.create_date}`}</div>]
                                   ))}
                              </div>
                              <div className={classes.jobcardSummary}></div>
                          </Fragment>
                         }

                         {/*site visits*/}
                         {summary.site_visits !== undefined &&
                          summary.site_visits !== null &&
                          summary.site_visits.length > 0 &&
                          <Fragment>
                            <div className={classes.bigTitle}>Site Visits</div>
                               <div className={classes.siteVisits}>
                                   <div className={classes.title}>Start Time</div>
                                   <div className={classes.title}>Stop Time</div>
                                   <div className={classes.title}>Name</div>

                                   {summary.site_visits.map((visit, index) => (
                                        [<div key={`${index}_0`}>{`${visit.start_time}`}</div>,
                                         <div key={`${index}_1`}>{`${visit.stop_time}`}</div>,
                                         <div key={`${index}_2`}>{`${visit.name}`}</div>]
                                    ))}
                               </div>
                               <div className={classes.siteVisitsSummary}></div>
                           </Fragment>
                          }


                          </div>
                  </div>
                  </div>
              </Grid>

          </Grid>
      }
      <Dialog open={openPaperFriendlyAlertDialog} onClose={handleClosePaperFriendlyAlertDialog} disableBackdropClick={false}

          PaperProps={{
            style: {
              boxShadow: 'none',
            },
          }}
      >
        <DialogTitle className={classes.title}>Paper Saver ON</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please make sure to select <b>Landscape layout</b> while printing with Paper Saver on.
            <br/>
            <img src={layoutImage}/>
          </DialogContentText>

        </DialogContent>
        <DialogActions>
            <Button onClick={handleClosePaperFriendlyAlertDialog}>
              OK
            </Button>
        </DialogActions>
      </Dialog>
      </div>
    );
});
export default ViewInvoicingSummary;
